export default __webpack_public_path__ + "static/media/kitchen3-afterF-1920w.02269dda.png";